import { formatPhoneNumber } from "./phoneUtils";

export const DEFAULT_LINE_FORMATS = {
  line1Format: "text",
  line2Format: "text",
  line3Format: "text",
};

export const formatKeyForLine = (line) => `${line}Format`;

export const getLineFormat = (config, line) =>
  config?.[formatKeyForLine(line)] || "text";

export const applyLineFormat = (value, format) => {
  if (!value) return "";
  if (format === "phone") return formatPhoneNumber(value);
  return value;
};

export const formatEngraveDisplay = (text, lineFormat, textCase) => {
  if (!text) return "";
  if (lineFormat === "phone") return formatPhoneNumber(text);

  if (textCase === "uppercase") return text.toUpperCase();

  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const collectLineFormats = (config) => ({
  line1: getLineFormat(config, "line1"),
  line2: getLineFormat(config, "line2"),
  line3: getLineFormat(config, "line3"),
});
